import AgGridMixin from './ag-grid-mixin';

export default {
  mixins: [AgGridMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargando: {
      type: Boolean,
      required: true,
    },
  },
};
